import {
  Activity,
  ActivityTeaserFragmentFragment,
  Hotel,
  HotelFragmentFragment,
  InfolinoHotelFragmentFragment,
  ParagraphActivityTabData,
  ParagraphActivityTabsFragmentFragment,
  TermCategory,
} from '../generated/types';
import { Maybe } from 'graphql/jsutils/Maybe';
import groupBy from 'lodash/groupBy';
import { useMemo } from 'react';

type GroupType = Array<{
  __typename: 'ParagraphActivityTabData';
  category: TermCategory;
  items: ActivityTeaserFragmentFragment[];
}>;

export default function useHotelGroupedData(
  data: HotelFragmentFragment | InfolinoHotelFragmentFragment
) {
  return useMemo(() => {
    let groupedActivities: GroupType = [];
    if ('activities' in data) {
      if (data.activities) {
        const grouped = groupBy(data.activities, 'category.id');

        Object.keys(grouped).forEach((categoryTermId) => {
          groupedActivities!.push({
            __typename: 'ParagraphActivityTabData',
            category: grouped[categoryTermId][0].category!,
            items: grouped[categoryTermId],
          });
        });
      }
    }

    let groupedActivitiesFreizeithotels: GroupType = [];
    if (data.activitiesFreizeithotels) {
      const grouped = groupBy(data.activitiesFreizeithotels, 'category.id');

      Object.keys(grouped).forEach((categoryTermId) => {
        groupedActivitiesFreizeithotels!.push({
          __typename: 'ParagraphActivityTabData',
          category: grouped[categoryTermId][0].category!,
          items: grouped[categoryTermId],
        });
      });
    }

    return {
      groupedActivities,
      groupedActivitiesFreizeithotels,
    };
  }, [data]);
}
